import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { JwtModule } from '@auth0/angular-jwt';

// import { AuthInterceptor } from './core/interceptors/auth.interceptor';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/*import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';*/
//FOR CHARTS
import { NgxChartsModule } from '@swimlane/ngx-charts'; // Importa NgxChartsModule

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HeaderComponent } from './components/header/header.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { EmpresaFormComponent } from './components/dashboard/roles_permission/empresa-form/empresa-form.component';
import { MdbAccordionModule } from 'mdb-angular-ui-kit/accordion';
import { MdbCarouselModule } from 'mdb-angular-ui-kit/carousel';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { MdbCollapseModule } from 'mdb-angular-ui-kit/collapse';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbModalModule } from 'mdb-angular-ui-kit/modal';
import { MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbRadioModule } from 'mdb-angular-ui-kit/radio';
import { MdbRangeModule } from 'mdb-angular-ui-kit/range';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { MdbScrollspyModule } from 'mdb-angular-ui-kit/scrollspy';
import { MdbTabsModule } from 'mdb-angular-ui-kit/tabs';
import { MdbTooltipModule } from 'mdb-angular-ui-kit/tooltip';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbSidenavModule } from 'mdb-angular-ui-kit/sidenav';
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';
import { MdbChipsModule } from 'mdb-angular-ui-kit/chips';
import { MdbLoadingModule } from 'mdb-angular-ui-kit/loading';
import { MdbFileUploadModule } from 'mdb-angular-file-upload';
import { ModalAppsComponent } from './components/crud/modal-apps/modal-apps.component';
import { ModalMenuComponent } from './components/crud/modal-menu/modal-menu.component';

import { DocumentosModule } from './modules/documentos/documentos.module';

import { SsomaModule } from './modules/ssoma/ssoma.module';

import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { A11yModule } from '@angular/cdk/a11y';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { PdfViewerContainerComponent } from './pdf-viewer-container/pdf-viewer-container.component';

import { DataDocumentService } from './services/data-document.service';

import { AppRoutingModule } from './app-routing.module';

import { TokenInterceptor } from './interceptors/token.interceptor';
import { ModalCompanyComponent } from './components/crud/modal-company/modal-company.component';

import { ModalDocumentosSgiComponent } from './components/crud/modal-documentos-sgi/modal-documentos-sgi.component';
import { ModalCloneProfileComponent } from './components/crud/modal-clone-profile/modal-clone-profile.component';
import { ModalDocumentosDetailsComponent } from './components/crud/modal-documentos-detail/modal-documentos-detail.component';
import { ModalAddCodeComponent } from './components/crud/modal-add-code/modal-add-code.component';
import { ModalSeeCodeRequestComponent } from './components/crud/modal-see-code-request/modal-see-code-request.component';
import { ModalDeclareRejectionReasonComponent } from './components/crud/modal-declare-rejection-reason/modal-declare-rejection-reason.component';
import { ModalSeeBinnacleComponent } from './components/crud/modal-see-binnacle/modal-see-binnacle.component';
import { DatavisualizationModule } from './modules/datavisualization/datavisualization.module';
import { AdminModule } from './modules/admin/admin.module';
import { ModalWorkOrdersComponent } from './components/crud/modal-work-orders/modal-work-orders.component';
import { ModalMaintenanceOtComponent } from './components/crud/modal-maintenance-ot/modal-maintenance-ot.component';
import { ModalNewBinnacleOtComponent } from './components/crud/modal-new-binnacle-ot/modal-new-binnacle-ot.component';
import { ModalNewBinnacleComponent } from './components/crud/modal-new-binnacle/modal-new-binnacle.component';
import { ModalSeeWorkOrderComponent } from './components/crud/modal-see-work-order/modal-see-work-order.component';

@NgModule({
  declarations: [
    LoginComponent,
    AppComponent,
    DashboardComponent,
    HeaderComponent,
    PageNotFoundComponent,
    EmpresaFormComponent,
    PdfViewerContainerComponent,
    ModalCompanyComponent,
    ModalAppsComponent,
    ModalMenuComponent,
    ModalDocumentosSgiComponent,
    ModalCloneProfileComponent,
    ModalDocumentosDetailsComponent,
    ModalAddCodeComponent,
    ModalSeeCodeRequestComponent,
    ModalDeclareRejectionReasonComponent,
    ModalSeeBinnacleComponent,
    ModalWorkOrdersComponent,
    ModalMaintenanceOtComponent,
    ModalNewBinnacleOtComponent,
    ModalNewBinnacleComponent,
    ModalSeeWorkOrderComponent,
  ],
  imports: [
    AdminModule,
    AppRoutingModule,
    ReactiveFormsModule,
    SweetAlert2Module.forRoot(),
    MdbChipsModule,
    MdbTableModule,
    MdbFormsModule,
    FormsModule,
    A11yModule,
    DocumentosModule,
    SsomaModule,
    MdbDatepickerModule,
    MdbSidenavModule,
    MdbRippleModule,
    MdbCollapseModule,
    NgxChartsModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    /*MatInputModule,
    MatButtonModule,
    MatToolbarModule,
    MatCardModule,
    MatSelectModule,*/
    MdbSelectModule,
    FormsModule,
    ReactiveFormsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem('token'); // Asegúrate de tener implementado este método en tu AuthService
        },
        allowedDomains: ['*'], // Domains permitidos para el token
        disallowedRoutes: ['example.com/auth/login'], // Rutas excluidas del token
      },
    }),
    MdbAccordionModule,
    MdbCarouselModule,
    MdbCheckboxModule,
    MdbCollapseModule,
    MdbDropdownModule,
    MdbFormsModule,
    MdbModalModule,
    MdbPopoverModule,
    MdbRadioModule,
    MdbRangeModule,
    MdbRippleModule,
    MdbScrollspyModule,
    MdbTabsModule,
    MdbTooltipModule,
    MdbValidationModule,
    MdbSidenavModule,
    MdbCollapseModule,
    MdbLoadingModule,
    MdbFileUploadModule,
    DatavisualizationModule,
  ],
  providers: [
    DataDocumentService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
